import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import classes from './Unauthorized.module.css'
import { Container } from 'react-bootstrap';

const Unauthorized = props => {
  const location = useLocation();
  const { state }  = location;
  return (
    <Container className={classes.container}>
      <h1 className={classes.heading}>403 - ACCESS DENIED</h1>
      {state && (
        <p>
          You are Unauthorized for{" "}
          <b className={classes.link}>
            {(window.location.host ?? "") + (state?.from?.pathname ?? "")}
          </b>
        </p>
      )}
      <p className={classes.goto}>
        Go to{" "}
        <Link to="/" className="sec-btn1">
          Dashboard <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </p>
    </Container>
  );
}

export default Unauthorized
